import React from "react"
import {
  Avatar, Box, Grid, GridItem, Text,
} from "@chakra-ui/react"
import { Speaker as SpeakerType, Website } from "sharedTypes"
import Button from "components/Buttons/Button"
import SectionHeader from "./SectionHeader"
import SpeakerModal from "../components/SpeakerModal/SpeakerModal"

const Speakers = ({
  speakers, website, onEditSpeaker, onAddSpeaker,
}: {
  speakers: SpeakerType[]
  website?: Website
  onEditSpeaker?: (speaker: SpeakerType) => void
  onAddSpeaker?: () => void
}) => {
  const speakersEnabled = !website || website.speakersEnabled !== false
  const headerText = website?.speakersHeader || "Speakers"

  let content: React.ReactNode
  if (!speakers.length) {
    if (!onAddSpeaker) {
      content = <SectionHeader text={headerText} />
    } else {
      content = (
        <>
          <SectionHeader text={headerText} />
          <Box textAlign="center" mb={16} mt={20}>
            <Text color="gray.600" mb={4}>
              There are no speakers yet.
            </Text>
            <Button size="sm" variant="outline" leftIcon="plus" onClick={onAddSpeaker}>
              Add first speaker
            </Button>
          </Box>
        </>
      )
    }
  } else {
    content = (
      <>
        <SectionHeader text={headerText} />
        <Grid templateColumns="repeat(6, 1fr)" gap={4} mt={20}>
          {speakers.map((speaker, index) => (
            <GridItem key={index} colSpan={{ base: 6, md: 3, lg: 2 }}>
              <Speaker speaker={speaker} onEdit={onEditSpeaker} />
            </GridItem>
          ))}
        </Grid>
      </>
    )
  }

  return (
    <Box opacity={speakersEnabled ? 1 : 0.5} transition="opacity 0.2s">
      {content}
    </Box>
  )
}

const Speaker = ({
  speaker: {
    company, name, title, photoUrl,
  },
  speaker,
  onEdit,
}: {
  speaker: SpeakerType
  onEdit?: (speaker: SpeakerType) => void
}) => (
  <Box textAlign="center" mb={16}>
    <SpeakerModal
      speaker={speaker}
      trigger={(
        <>
          <Avatar name={name} src={photoUrl} size="2xl" mb={3} bg="gray.300" />
          <Text fontWeight="bold">{name}</Text>
          {(title || company) && (
            <Text>{[title, company].filter(Boolean).join(", ")}</Text>
          )}
        </>
      )}
    />
    {onEdit && (
      <Button
        size="xs"
        variant="outline"
        mt={3}
        onClick={(e) => {
          e.stopPropagation()
          onEdit(speaker)
        }}
      >
        Edit
      </Button>
    )}
  </Box>
)

export default Speakers
